import {
  Box,
  Button,
  Checkbox,
  Drawer,
  InputAdornment,
  TextField,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { useEffect, useState, useMemo } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";

export const SettingsFilterOemAdmin = ({
  openFilter,
  toggleDrawer,
  selectedCountries = [],
  selectedEcus = [],
  selectedStatus = "ALL",
  handleFilterApiCalls,
}) => {
  const [countryOpen, setCountryOpen] = useState(true);
  const [ecuOpen, setEcuOpen] = useState(true);
  const [countryListchecked, setCountryListchecked] = useState([]);
  const [ecuTypechecked, setEcuTypechecked] = useState([]);
  const [searchCountry, setSearchCountry] = useState("");
  const [searchEcuType, setSearchEcuType] = useState("");
  const [appsType, setAppsType] = useState("ALL");
  const [appsStatus, setAppsStatus] = useState("ALL");
  const [isInitialized, setIsInitialized] = useState(false);

  const customPortal = sessionStorage.getItem("customPortal");

  const handleCountryClick = () => {
    setCountryOpen(!countryOpen);
  };

  const handleCountryToggle = (value) => () => {
    const countryId = customPortal === "oem-admin" ? value.iso3Code : value;
    const currentIndex = countryListchecked.findIndex((item) => {
      const itemId = customPortal === "oem-admin" ? item.iso3Code : item;
      return itemId === countryId;
    });
    const newChecked = [...countryListchecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setCountryListchecked(newChecked);
  };

  const handleApplyFilters = () => {
    let data = {
      selectedCountries: countryListchecked,
      selectedEcus: ecuTypechecked,
      selectedType: appsType,
      selectedStatus: appsStatus,
    };
    handleFilterApiCalls(data);
    toggleDrawer(false)();
  };

  const handleClearAllSelection = () => {
    setCountryListchecked([]);
    setEcuTypechecked([]);
    setSearchCountry("");
    setSearchEcuType("")  
    setAppsType("ALL");
    setAppsStatus("ALL");
  };

  const handleCountrySearch = (event) => {
    setSearchCountry(event.target.value);
  };

  const isCountryChecked = (country) => {
    const countryId = customPortal === "oem-admin" ? country.iso3Code : country;
    return countryListchecked.some((item) => {
      const itemId = customPortal === "oem-admin" ? item.iso3Code : item;
      return itemId === countryId;
    });
  };

  const handleUnselectCountry = () => {
    const validCountries = selectedCountries.filter((item) => item !== "");
    const isAllSelected = countryListchecked.length === validCountries.length && validCountries.length > 0;
    
    if (isAllSelected) {
      // Currently all selected, so unselect all
      setCountryListchecked([]);
    } else {
      // Not all selected, so select all
      setCountryListchecked(validCountries);
    }
  };
  const filteredCountry = useMemo(() => {
    const filtered = selectedCountries?.filter((country) => {
      const countryText = customPortal === "oem-admin" ? country.name : country;
      return searchCountry
        ? countryText.toLowerCase().includes(searchCountry.toLowerCase())
        : countryText;
    });
    
    const sorted = [...(filtered || [])];
    sorted.sort((a, b) => {
      const nameA = customPortal === "oem-admin" ? a.name : a;
      const nameB = customPortal === "oem-admin" ? b.name : b;
      return nameA.localeCompare(nameB);
    });
    return sorted;
  }, [searchCountry, selectedCountries, customPortal]);

  const filteredEcu = useMemo(() => {
    return selectedEcus?.filter((item) =>
      item.toLowerCase().includes(searchEcuType.toLowerCase())
    );
  }, [searchEcuType, selectedEcus]);

  useEffect(() => {
    // Only initialize once when the component first receives data
    if (!isInitialized && openFilter) {
      if (selectedEcus.length > 0) {
        setEcuTypechecked(selectedEcus);
      }
      if (selectedCountries.length > 0) {
        const filteredCountries = selectedCountries.filter((item) => item !== "");
        setCountryListchecked(filteredCountries);
      }
      setIsInitialized(true);
    }
  }, [selectedEcus, selectedCountries, openFilter, isInitialized]);

  useEffect(() => {
    if (openFilter) {
      // Reset search states when filter drawer opens
      setSearchCountry("");
      setSearchEcuType("");
    }
  }, [openFilter]);

  const handleEcuSearch = (e) => {
    setSearchEcuType(e.target.value);
  };

  const handleEcuToggle = (value) => () => {
    const currentIndex = ecuTypechecked.indexOf(value);
    const newChecked = [...ecuTypechecked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setEcuTypechecked(newChecked);
  };

  const handleSelectUnselectEcu = () => {
    const isAllSelected = ecuTypechecked.length === selectedEcus.length && selectedEcus.length > 0;
    
    if (isAllSelected) {
      // Currently all selected, so unselect all
      setEcuTypechecked([]);
    } else {
      // Not all selected, so select all
      setEcuTypechecked([...selectedEcus]);
    }
  };

 const handleRoleChange = (event) => {
  setAppsType(event.target.value);
  setSearchCountry("");
  setSearchEcuType("");
};

  const handleStatusChange = (event) => {
    setAppsStatus(event.target.value);
  };

  useEffect(() => {
    if (openFilter) {
      setAppsStatus(selectedStatus || "ALL");
    }
  }, [openFilter, selectedStatus]);

  return (
    <Drawer open={openFilter} onClose={toggleDrawer(false)} anchor="right">
      <div
        className="filterContainer"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div className="filterHeaderCls">
          <span>Filter</span>
          <span>
            <CloseIcon className="closeIconCls" onClick={toggleDrawer(false)} />
          </span>
        </div>
        <div
          className="filterContentCls"
          style={{
            flex: 1,
            overflowY: "auto",
            paddingBottom: "16px",
            padding: "16px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              marginBottom: "12px",
              display: "block",
            }}
          >
            Apps From
          </span>
          <FormControl sx={{ width: "100%" }}>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              value={appsType}
              name="radio-buttons-group"
              onChange={handleRoleChange}
              sx={{
                gap: "4px",
                width: "100%",
                flexWrap: "nowrap",
              }}
            >
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  flex: "1",
                  minWidth: "0",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    fontWeight: "500",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="ALL"
                control={<Radio size="small" />}
                label="ALL"
              />
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  flex: "1",
                  minWidth: "0",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "11px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="OEM"
                control={<Radio size="small" />}
                label="OEM Apps"
              />
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  flex: "1",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "11px",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="3RD"
                control={<Radio size="small" />}
                label="3rd Party Apps"
              />
            </RadioGroup>
          </FormControl>

          <span
            style={{
              fontWeight: "bold",
              marginTop: "16px",
              marginBottom: "12px",
              display: "block",
            }}
          >
            Apps Status
          </span>
          <FormControl sx={{ width: "100%" }}>
            <RadioGroup
              row
              value={appsStatus}
              onChange={handleStatusChange}
              sx={{
                gap: "6px",
                width: "100%",
                flexWrap: "nowrap",
              }}
            >
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  paddingRight: "32px",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    fontWeight: "500",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="ALL"
                control={<Radio size="small" />}
                label="All"
              />
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  paddingRight: "32px",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    fontWeight: "500",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="ACTIVE"
                control={<Radio size="small" />}
                label="Active"
              />
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  paddingRight: "32px",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    fontWeight: "500",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="EXPIRED"
                control={<Radio size="small" />}
                label="Expired"
              />
              <FormControlLabel
                sx={{
                  border: "1px solid #12141533",
                  height: "35px!important",
                  borderRadius: "4px",
                  margin: "0",
                  paddingRight: "32px",
                  "& .MuiFormControlLabel-label": {
                    fontSize: "12px",
                    fontWeight: "500",
                  },
                  "& .MuiRadio-root": {
                    padding: "6px",
                  },
                }}
                value="FUTURE"
                control={<Radio size="small" />}
                label="Future"
              />
            </RadioGroup>
          </FormControl>

          {/* ECU Type section */}
          {customPortal === "oem-admin" && (
            <List
              sx={{ width: "100%", maxWidth: 383, bgcolor: "background.paper" }}
              component="nav"
              aria-labelledby="nested-list-subheader"
              id="ecuType"
            >
              <ListItemButton
                onClick={() => setEcuOpen(!ecuOpen)}
                sx={{ fontSize: "14px", fontWeight: "500", color: "#121415" }}
              >
                {ecuOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                <ListItemText
                  primary="ECU Type"
                  disableTypography
                  sx={{
                    fontSize: "16px !important",
                    fontWeight: "600 !important",
                    color: "#121415",
                  }}
                />
                {ecuTypechecked.length}/{selectedEcus.length}
              </ListItemButton>
              <Collapse in={ecuOpen} timeout="auto" unmountOnExit>
                <div className="versionListDivCls">
                  <Box
                    className="searchCreateBtnCls"
                    component="form"
                    noValidate
                    autoComplete="off"
                  >
                    <button
                      type="button"
                      className="selectAllTextCls"
                      onClick={handleSelectUnselectEcu}
                    >
                      {ecuTypechecked.length === selectedEcus.length &&
                      selectedEcus.length > 0
                        ? "Unselect All"
                        : "Select All"}
                    </button>
                    <TextField
                      type="search"
                      placeholder="Search for ECU Type"
                      size="small"
                      style={{ backgroundColor: "white" }}
                      onChange={handleEcuSearch}
                      slotProps={{
                        input: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </Box>
                </div>
                <div className="listDivCls">
                  {filteredEcu.map((ecu) => (
                    <List
                      key={ecu}
                      component="div"
                      sx={{ paddingTop: "2px", paddingBottom: "2px" }}
                    >
                      <ListItemButton
                        sx={{
                          minWidth: "0px",
                          borderRadius: "4px",
                          paddingTop: "0px",
                          paddingBottom: "0px",
                          backgroundColor: ecuTypechecked.includes(ecu)
                            ? "#E5F3FF"
                            : "",
                          color: ecuTypechecked.includes(ecu) ? "#0476E2" : "",
                          cursor: "default",
                        }}
                        onClick={handleEcuToggle(ecu)}
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={ecuTypechecked.includes(ecu)}
                            tabIndex={-1}
                            disableRipple
                          />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            marginLeft: "-32px",
                          }}
                          primary={ecu}
                        />
                      </ListItemButton>
                    </List>
                  ))}
                </div>
              </Collapse>
            </List>
          )}

          {/* Country section */}
          <List
            sx={{ width: "100%", maxWidth: 383, bgcolor: "background.paper" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            id="country"
          >
            <ListItemButton
              onClick={handleCountryClick}
              sx={{ fontSize: "14px", fontWeight: "500", color: "#121415" }}
            >
              {countryOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              <ListItemText
                primary="Country"
                disableTypography
                sx={{
                  fontSize: "16px !important",
                  fontWeight: "600 !important",
                  color: "#121415",
                }}
              />
              {countryListchecked.length}/
              {selectedCountries.filter((country) => country !== "").length}
            </ListItemButton>
            <Collapse in={countryOpen} timeout="auto" unmountOnExit>
              <div className="versionListDivCls">
                <Box
                  className="searchCreateBtnCls"
                  component="form"
                  noValidate
                  autoComplete="off"
                >
                  <button
                    type="button"
                    className="selectAllTextCls"
                    onClick={handleUnselectCountry}
                  >
                    {countryListchecked.length === selectedCountries.filter((country) => country !== "").length &&
                    selectedCountries.some((country) => country !== "")
                      ? "Unselect All"
                      : "Select All"}
                  </button>
                  <TextField
                    type="search"
                    placeholder="Search for Country"
                    size="small"
                    style={{
                      backgroundColor: "white",
                    }}
                    slotProps={{
                      input: {
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      },
                    }}
                    onChange={handleCountrySearch}
                  />
                </Box>
              </div>
              <div className="listDivCls">
                {filteredCountry
                  .filter((country) => country !== "")
                  .map((country, index) => (
                    <List
                      key={
                        customPortal === "oem-admin"
                          ? country.iso3Code || index
                          : country
                      }
                      component="div"
                      sx={{
                        paddingTop: "2px!important",
                        paddingBottom: "2px!important",
                      }}
                    >
                      <ListItemButton
                        sx={{
                          minWidth: "0px !important",
                          borderRadius: "4px!important",
                          paddingTop: "0px!important",
                          paddingBottom: "0px!important",
                          backgroundColor: isCountryChecked(country)
                            ? "#E5F3FF"
                            : "",
                          color: isCountryChecked(country)
                            ? "#0476E2"
                            : "",
                          cursor: "default",
                        }}
                        onClick={handleCountryToggle(country)}
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={isCountryChecked(country)}
                            tabIndex={-1}
                            disableRipple
                            slotProps={{ "aria-labelledby": country }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          disableTypography
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            marginLeft: "-32px",
                          }}
                          primary={
                            customPortal === "oem-admin"
                              ? country.name
                              : country
                          }
                        />
                      </ListItemButton>
                    </List>
                  ))}
              </div>
            </Collapse>
          </List>
        </div>
        <div
          className="filterFooterCls"
          style={{
            position: "relative",
            marginTop: "auto",
            flexShrink: 0,
          }}
        >
          <button type="button" className="clearAllCls" onClick={handleClearAllSelection}>
            Clear All
          </button>
          <div>
            <Button
              onClick={toggleDrawer(false)}
              color="primary"
              sx={{
                textTransform: "none",
                background: "#1214151A",
                color: "#2A2C2D",
              }}
            >
              Cancel
            </Button>
            &nbsp;&nbsp;
            <Button
              color="primary"
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={handleApplyFilters}
              disabled = {countryListchecked.length === 0 || ecuTypechecked.length === 0}
            >
              Apply
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

SettingsFilterOemAdmin.propTypes = {
  openFilter: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  selectedCountries: PropTypes.array,
  selectedEcus: PropTypes.array,
  selectedStatus: PropTypes.string,
  handleFilterApiCalls: PropTypes.func,
};
